import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e1868730"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section-tour-date" }
const _hoisted_2 = { class: "tour-info" }
const _hoisted_3 = { class: "date" }
const _hoisted_4 = { class: "day-location" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 問診票へ ")
const _hoisted_7 = { class: "notice" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 問診票は ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 以降に")
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" ご入力いただけます ")
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 登録済み ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppButtonPrimary = _resolveComponent("AppButtonPrimary")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.tour.dateString), 1),
      _createElementVNode("div", _hoisted_4, " (" + _toDisplayString(_ctx.tour.dayOfTheWeek) + _toDisplayString(_ctx.tour.isHoliday ? '･祝' : '') + ") / " + _toDisplayString(_ctx.tour.location), 1)
    ]),
    (!_ctx.tour.hasPast)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_AppButtonPrimary, {
            class: "button",
            active: _ctx.active,
            "show-caret": false,
            onButton: _ctx.toQuestionnaire
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }, 8, ["active", "onButton"]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("span", null, _toDisplayString(_ctx.month) + "/" + _toDisplayString(_ctx.date) + " 0:00AM", 1),
            _hoisted_9,
            _hoisted_10,
            _hoisted_11
          ])
        ]))
      : (_ctx.tour.hasPast && _ctx.questionnaireFilledOut)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createVNode(_component_AppButtonPrimary, {
              class: "button",
              active: false,
              "show-caret": false
            }, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
  ]))
}